import { IqGameOver } from './IqGameOver.tsx';
import { IqHud } from './IqHud.tsx';
import { IqPause } from './IqPause.tsx';

/** Входной адаптер (in): DOM-HUD для iq; фон и ответы — в canvas и React overlays. */
export function IqTvOverlays() {
  return (
    <>
      <IqHud />
      <IqPause />
      <IqGameOver />
    </>
  );
}
